import SidebarToggle from "../ui/sidebar-toggle";
import BusinessContext from "../../contexts/business-context";
import { useContext, useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";

const LOGO_URL = (scheme) => `https://cdn.workpeg.com/pegs/home/assets/logo/primary-${scheme}.svg`;

const MainMenuItems = ({ children }) => {
  const businessCtx = useContext(BusinessContext);
  const business = businessCtx.activeBusiness;
  // Same Workpeg logo (and light/dark switch) the pegment sidebar uses.
  const [colorScheme, setColorScheme] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );

  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e) => setColorScheme(e.matches ? 'dark' : 'light');
    media.addEventListener('change', handler);
    return () => media.removeEventListener('change', handler);
  }, []);

  return (
    <div className="grid gap-[28px] content-start">
      <div className={`flex items-center justify-between ${business.is_pseudonymous ? '' : 'mx-[20.5px] lg:mx-0 lg:ml-[30px] lg:mr-[18px]'} `}>
        <Link href={`/${business.uuid}/dashboard`} className="lg:p-[10px]">
          <Image width={92} height={15} src={LOGO_URL(colorScheme)} alt="Workpeg" />
        </Link>
        <SidebarToggle />
      </div>
      <div className="grid h-full h-fit overflow-y-auto overflow-x-hidden custom-scrollbar lg:px-[17.5px]">
        <div className="grid gap-4">
          {children}
        </div>
      </div>
    </div>
  );
}

export default MainMenuItems;
